<div mat-dialog-title class="cust-modal-title">
  <h2 class="m-0">Add/edit member package</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content *ngIf="!loader && !editmode">
  <div class="row">
    <div class="col-sm-12">
      <div class="member_profile">
        <div class="bgt_colorkk"></div>
        <img
          [src]="memberDetailsData.image_thumb_url"
          onerror="this.src='../../../../assets/images/user-avatar.svg'"
          alt=""
        />
      </div>
      <div
        style="
          margin-bottom: 30px;
          display: flex;
          align-items: baseline;
          text-decoration: underline;
          justify-content: end;
        "
      >
        <div>
          <span
            class="material-icons icon_mat"
            style="font-size: 20px; top: 5px"
          >
            edit
          </span>
        </div>
        <div style="cursor: pointer; font-size: 14px" (click)="onEdit()">
          Edit
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> person </span>
          </div>
          <div class="entity_detail make_text_grey">Name</div>
        </div>
        <div class="sub_one_cont main_text">
          <div class="entity_detail" style="margin-left: 30px; font-size: 16px">
            {{ memberDetailsData.name }}
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> call </span>
          </div>
          <div class="entity_detail make_text_grey">Phone</div>
        </div>
        <div class="sub_one_cont main_text">
          <div class="entity_detail" style="margin-left: 30px; font-size: 16px">
            {{ memberDetailsData.country_code }} {{ memberDetailsData.phone }}
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> mail </span>
          </div>
          <div class="entity_detail make_text_grey">Email</div>
        </div>
        <div class="sub_one_cont main_text">
          <div class="entity_detail" style="margin-left: 30px; font-size: 16px">
            {{
              memberDetailsData.email
                ? memberDetailsData.email
                : "No email added"
            }}
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> transgender </span>
          </div>
          <div class="entity_detail make_text_grey">Gender</div>
        </div>
        <div class="sub_one_cont main_text">
          <div class="entity_detail" style="margin-left: 34px; font-size: 16px">
            {{ memberDetailsData.gender }}
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> calendar_month </span>
          </div>
          <div class="entity_detail make_text_grey">DOB</div>
        </div>
        <div class="sub_one_cont main_text">
          <div class="entity_detail" style="margin-left: 34px; font-size: 16px">
            {{
              memberDetailsData.dob
                ? (memberDetailsData.dob | date)
                : "No DOB added"
            }}
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> calendar_month </span>
          </div>
          <div class="entity_detail make_text_grey" style="margin-bottom: 8px">
            Membership start date
          </div>
        </div>
        <div class="sub_one_cont main_text">
          <div class="sub_one_cont main_text">
            <div
              class="entity_detail"
              style="margin-left: 34px; font-size: 16px"
            >
              {{ memberDetailsData.membership_start_date | date }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> settings </span>
          </div>
          <div class="entity_detail make_text_grey" style="margin-bottom: 8px">
            Service mode
          </div>
        </div>
        <div class="sub_one_cont main_text">
          <div class="sub_one_cont main_text">
            <div
              class="entity_detail"
              style="margin-left: 34px; font-size: 16px"
            >
              {{ memberDetailsData.s_mode }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> list_alt </span>
          </div>
          <div class="entity_detail make_text_grey" style="margin-bottom: 8px">
            Opted services
          </div>
        </div>
        <div
          class="sub_one_cont main_text"
          *ngIf="memberDetailsData.opted_services"
        >
          <div class="sub_one_cont main_text">
            <div
              class="entity_detail"
              style="margin-left: 34px; font-size: 16px"
            >
              {{ memberDetailsData.opted_services }}
            </div>
          </div>
        </div>
        <div
          class="sub_one_cont main_text"
          *ngIf="!memberDetailsData.opted_services"
        >
          <div class="sub_one_cont main_text">
            <div
              class="entity_detail"
              style="margin-left: 34px; font-size: 16px"
            >
              No opted services
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> list_alt </span>
          </div>
          <div class="entity_detail make_text_grey" style="margin-bottom: 8px">
            Opted products
          </div>
        </div>
        <div
          class="sub_one_cont main_text"
          *ngIf="memberDetailsData.opted_products"
        >
          <div class="sub_one_cont main_text">
            <div
              class="entity_detail"
              style="margin-left: 34px; font-size: 16px"
            >
              {{ memberDetailsData.opted_products }}
            </div>
          </div>
        </div>
        <div
          class="sub_one_cont main_text"
          *ngIf="!memberDetailsData.opted_products"
        >
          <div class="sub_one_cont main_text">
            <div
              class="entity_detail"
              style="margin-left: 34px; font-size: 16px"
            >
              No opted products
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> list_alt </span>
          </div>
          <div class="entity_detail make_text_grey" style="margin-bottom: 8px">
            Other items
          </div>
        </div>
        <div class="sub_one_cont main_text" *ngIf="memberDetailsData.opted_cis">
          <div class="sub_one_cont main_text">
            <div
              class="entity_detail"
              style="margin-left: 34px; font-size: 16px"
            >
              {{ memberDetailsData.opted_cis }}
            </div>
          </div>
        </div>
        <div
          class="sub_one_cont main_text"
          *ngIf="!memberDetailsData.opted_cis"
        >
          <div class="sub_one_cont main_text">
            <div
              class="entity_detail"
              style="margin-left: 34px; font-size: 16px"
            >
              No other items
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="col-md-12"
      *ngIf="memberDetailsData.timings && memberDetailsData.timings != 'null'"
    >
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> work_history </span>
          </div>
          <div class="entity_detail make_text_grey" style="margin-bottom: 8px">
            Opted timings
          </div>
        </div>
        <div class="sub_one_cont main_text">
          <div class="entity_detail" style="margin-left: 30px">
            <mat-chip-listbox aria-label="sunday">
              <mat-chip *ngFor="let item of memberDetailsData.opted_timings">
                {{ item }}
              </mat-chip>
            </mat-chip-listbox>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> payments </span>
          </div>
          <div class="entity_detail make_text_grey">Subscription fees</div>
        </div>
        <div class="sub_one_cont main_text">
          <div
            class="entity_detail"
            style="margin-left: 34px; font-size: 16px"
            *ngIf="
              memberDetailsData.membership_fee &&
              memberDetailsData.membership_fee != 'null'
            "
          >
            {{ memberDetailsData.currency_symbol
            }}{{ memberDetailsData.membership_fee.toFixed(2) }}
          </div>
          <div
            class="entity_detail"
            style="margin-left: 34px; font-size: 16px"
            *ngIf="
              !memberDetailsData.membership_fee ||
              memberDetailsData.membership_fee == 'null'
            "
          >
            {{ memberDetailsData.currency_symbol }}0.00
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> payments </span>
          </div>
          <div class="entity_detail make_text_grey">Discount</div>
        </div>
        <div class="sub_one_cont main_text">
          <div
            class="entity_detail"
            style="margin-left: 34px; font-size: 16px"
            *ngIf="
              memberDetailsData.discount && memberDetailsData.discount != 'null'
            "
          >
            {{ memberDetailsData.currency_symbol
            }}{{ memberDetailsData.discount.toFixed(2) }}
          </div>
          <div
            class="entity_detail"
            style="margin-left: 34px; font-size: 16px"
            *ngIf="
              !memberDetailsData.discount ||
              memberDetailsData.discount == 'null'
            "
          >
            {{ memberDetailsData.currency_symbol }}0.00
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> payments </span>
          </div>
          <div class="entity_detail make_text_grey">Net payable</div>
        </div>
        <div class="sub_one_cont main_text">
          <div
            class="entity_detail"
            style="margin-left: 34px; font-size: 16px"
            *ngIf="
              memberDetailsData.net_payable &&
              memberDetailsData.net_payable != 'null'
            "
          >
            {{ memberDetailsData.currency_symbol
            }}{{ memberDetailsData.net_payable.toFixed(2) }}
          </div>
          <div
            class="entity_detail"
            style="margin-left: 34px; font-size: 16px"
            *ngIf="
              !memberDetailsData.net_payable ||
              memberDetailsData.net_payable == 'null'
            "
          >
            {{ memberDetailsData.currency_symbol }}0.00
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> payments </span>
          </div>
          <div class="entity_detail make_text_grey">Notes</div>
        </div>
        <div class="sub_one_cont main_text">
          <div class="entity_detail" style="margin-left: 34px; font-size: 16px">
            {{
              memberDetailsData.notes && memberDetailsData.notes != "null"
                ? memberDetailsData.notes
                : "No notes added"
            }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="col-md-12"
      *ngIf="
        memberDetailsData.billing_period &&
        memberDetailsData.billing_period != 'null'
      "
    >
      <div class="sub_one sub_margin">
        <div class="sub_one_cont">
          <div>
            <span class="material-icons icon_mat"> payments </span>
          </div>
          <div class="entity_detail make_text_grey">Billing period</div>
        </div>
        <div class="sub_one_cont main_text">
          <div
            class="entity_detail"
            style="margin-left: 34px; font-size: 16px"
            *ngIf="memberDetailsData.billing_period == 1"
          >
            Weekly
          </div>
          <div
            class="entity_detail"
            style="margin-left: 34px; font-size: 16px"
            *ngIf="memberDetailsData.billing_period == 2"
          >
            Monthly
          </div>
          <div
            class="entity_detail"
            style="margin-left: 34px; font-size: 16px"
            *ngIf="memberDetailsData.billing_period == 3"
          >
            Yearly
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-content *ngIf="editmode">
 
  <h3 style="margin: 20px 0 0px" *ngIf="isEntityIndividual == '0'">
    {{
      selectedServiceType == "1"
        ? "Shop services"
        : selectedServiceType == "0"
        ? "Home services"
        : "Virtual services"
    }}
  </h3>
  <h3 style="margin: 20px 0 0px" *ngIf="isEntityIndividual == '1'">
    {{
      selectedServiceType == "1"
        ? "In-premise services"
        : selectedServiceType == "0"
        ? "Home services"
        : "Virtual services"
    }}
  </h3>
  <div class="chip_cont" style="padding: 20px 0px">
    <mat-chip-listbox class="example-chip" *ngIf="serviceList.length > 0">
      <div *ngFor="let item of serviceList">
        <mat-chip *ngIf="item.toShow" (click)="selectServices(item)"
          >{{ item.serviceName }}
        </mat-chip>
      </div>
    </mat-chip-listbox>
    <p *ngIf="serviceList.length == 0">No service added</p>
  </div>
  <!-- products -->
  <h3 style="margin: 20px 0 0px" *ngIf="productsList.length > 0">
    Sellable products
  </h3>
  <div
    class="chip_cont"
    style="padding: 20px 0px"
    *ngIf="productsList.length > 0"
  >
    <mat-chip-listbox class="example-chip" *ngIf="productsList.length > 0">
      <div *ngFor="let item of productsList">
        <mat-chip *ngIf="item.toShow" (click)="selectProducts(item)"
          >{{ item.product_name }}
        </mat-chip>
      </div>
    </mat-chip-listbox>
    <p *ngIf="productsList.length == 0">No product added</p>
  </div>

  <!-- selected services -->
  <h3
    *ngIf="selectedJobs.length > 0"
    style="font-weight: bold; font-size: 18px"
  >
    Job selected
  </h3>
  <div class="" *ngIf="selectedJobs.length > 0">
    <div class="job_complete_section" *ngFor="let item of selectedJobs; let i = index">
      <div class="first_div">
        <div
          style="
            display: inline-block;
            width: fit-content;
            background: #ffc107;
            padding: 8px 20px;
            border-radius: 34px;
            margin-bottom: 20px;
          "
        >
          <p style="margin: 0px; font-weight: 500; font-size: 16px">
            {{ item.serviceName }}
          </p>
        </div>
        <div class="produce_bill_sec">
        <div style="display: inline-block">
          <span
            style="
              margin-left: 10px;
              border: 1px solid #a2a2a2;
              padding: 10px;
              border-radius: 10px;
            "
          >
            <button
              (click)="decreaseServiceCount(item, i)"
              style="
                background: none;
                border: 1px solid #a2a2a2;
                border-radius: 25px;
                width: 25px;
                height: 25px;
              "
            >
              <mat-icon
                class="material-icons-outlined"
                style="
                  font-size: 16px;
                  position: relative;
                  top: 2px;
                  left: -3px;
                  color: #666666;
                  height: auto;
                  width: auto;
                "
                >remove</mat-icon
              >
            </button>
            <span style="margin: 0 15px"> {{ item.selectedCount }} </span>
            <button
              (click)="increaseServiceCount(item, i)"
              style="
                background: none;
                border: 1px solid #a2a2a2;
                border-radius: 25px;
                width: 25px;
                height: 25px;
              "
            >
              <mat-icon
                style="
                  font-size: 16px;
                  position: relative;
                  top: 2px;
                  left: -3px;
                  color: #666666;
                  height: auto;
                  width: auto;
                "
                class="material-icons-outlined"
                >add</mat-icon
              >
            </button>
          </span>

          
         
        </div>
       
        <div class="second-div" style="padding: 0">
        <div class="th_heading">
          <div
            style="position: relative; right: 20px; width: 80px"
            class="small-height-input"
          >
            <input
              [(ngModel)]="item.price"
              matInput
              smDecimalOnly
              type="number"
              (ngModelChange)="changeServicePrice(item)"
              style="width: 100px"
            />
            <!--  -->
          </div>
        </div>
      </div>
       </div>
         <div class="bill_down_flex">
             <span
            (click)="removeSelectedJobs(item,i)">
            Remove
          </span>
          </div>
      </div>
      
    </div>
  </div>



  <!-- selected products -->
  <h3
    *ngIf="selectedProducts.length > 0"
    style="font-weight: bold; font-size: 18px"
  >
    Selected products
  </h3>
  <div class="" *ngIf="selectedProducts.length > 0">
    <div class="job_complete_section" *ngFor="let item of selectedProducts; let i = index">
      <div class="first-div">
        <div
          style="
            display: inline-block;
            width: fit-content;
            background: #ffc107;
            padding: 8px 20px;
            border-radius: 34px;
            margin-bottom: 20px;
          "
        >
          <p style="margin: 0px; font-weight: 500; font-size: 16px">
            {{ item.product_name }}
          </p>
        </div>
        <!-- <mat-icon style="    font-size: 20px;
        font-weight: 900;
        color: #000;
        position: relative;
        top: 4px;
        margin-left: 10px;">close</mat-icon> -->
          <div class="produce_bill_sec">
        <div style="display: inline-block">
          <span
            style="
              margin-left: 10px;
              border: 1px solid #a2a2a2;
              padding: 10px;
              border-radius: 10px;
            "
          >
            <button
              (click)="decreaseProductCount(item, i)"
              style="
                background: none;
                border: 1px solid #a2a2a2;
                border-radius: 25px;
                width: 25px;
                height: 25px;
              "
            >
              <mat-icon
                class="material-icons-outlined"
                style="
                  font-size: 16px;
                  position: relative;
                  top: 2px;
                  left: -3px;
                  color: #666666;
                  height: auto;
                  width: auto;
                "
                >remove</mat-icon
              >
            </button>
            <span style="margin: 0 15px"> {{ item.selectedCount }} </span>
            <button
              (click)="increaseProductCount(item, i)"
              style="
                background: none;
                border: 1px solid #a2a2a2;
                border-radius: 25px;
                width: 25px;
                height: 25px;
              "
            >
              <mat-icon
                style="
                  font-size: 16px;
                  position: relative;
                  top: 2px;
                  left: -3px;
                  color: #666666;
                  height: auto;
                  width: auto;
                "
                class="material-icons-outlined"
                >add</mat-icon
              >
            </button>
          </span>
         
        </div>
         <div class="second-div" style="padding: 0">
        <div>
          <div
            style="position: relative; right: 20px; width: 80px"
            class="small-height-input"
          >
            <!-- <mat-label>Price</mat-label> -->
            <input
              [(ngModel)]="item.price"
              matInput
              smDecimalOnly
              type="number"
              (ngModelChange)="changeProductPrice(item)"
              style="width: 100px"
            />
            <!--  -->
          </div>
        </div>
      </div>
      </div>
           <div class="bill_down_flex">
             <span (click)="removeSelectedProducts(item,i)"> Remove</span>
          </div>
      </div>
     
    </div>
  </div>

  <!-- create invice new design added -->
  <div class="other_itemi_secty">
    <!-- <div class="oth_headingrt">
    <h3>Other item</h3>
  </div> -->
    <!-- <div class="repect_under" *ngFor="let item of repeatArray; let i = index">
  <div class="row">
    <div class="col-sm-6">
      <div class="item_name_tht">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Item name</mat-label>
            <input matInput type="text" placeholder="Enter item name">
          </mat-form-field>
      </div>
    </div>

    <div class="col-sm-6">
      
      <div class="plus_tht" style="padding-top: 14px;">
        <mat-icon class="serv_x">close</mat-icon>
        <div class="inc_dec_cont">
          <span class="cont_span">
            <button class="inc_dec_btn">
            <mat-icon >remove</mat-icon>
            </button>
            <span style="margin: 0 15px;"> 1 </span>
            <button 
            class="inc_dec_btn">
            <mat-icon class="material-icons-outlined">add</mat-icon>
            </button>
          </span>
          <span class="remove_btn" (click)="removeFormField(i)">Remove</span>
        </div>
      </div>

    </div>
  </div>
</div>

  <div class="add_item_btbh">
    <button mat-flat-button color="accent" (click)="addFormField()">
      <mat-icon>add</mat-icon>
      Add item
    </button>
  </div> -->

    <!-- <form [formGroup]="form">
    <div formArrayName="items">
      <div *ngFor="let item of items.controls; let i = index" [formGroupName]="i" class="repect_under">
        <div class="row">
          <div class="col-sm-3">
            <div class="item_name_tht">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Item name</mat-label>
                <input matInput formControlName="name" [matAutocomplete]="auto" type="text" placeholder="Enter item name">
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayItemName">
                  <mat-option *ngFor="let option of filteredOptions[i] | async" [value]="option">
                    {{ option.item_name }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>

              <div class="ddf">
            <mat-form-field appearance="outline" >
              <mat-select class="w-100" formControlName="tax_slab">
                          <mat-option value="default" >
                            Select a tax
                          </mat-option>
                          <mat-option [value]="item.hash_id" *ngFor="let item of taxSlabData">
                            {{isEntityForeign == '0' ? item.tax_name : item.slab_name}}
                          </mat-option>
                         
                        </mat-select>
           </mat-form-field>
          </div>
          
          </div>
          <div class="col-sm-3">
            <div class="plus_tht" style="padding-top: 0px;margin-bottom: 22px;">
              <mat-icon class="serv_x">close</mat-icon>
              <div class="inc_dec_cont">
                <span class="cont_span">
                  <button type="button" class="inc_dec_btn"  (click)="decreaseCount(i)">
                    <mat-icon>remove</mat-icon>
                  </button>
                  <span style="margin: 0 15px;">{{ item.get('count')!.value }}</span>
                  <button type="button" class="inc_dec_btn"  (click)="increaseCount(i)">
                    <mat-icon>add</mat-icon>
                  </button>
                </span>
                
              </div>
            </div>
          </div>
          <div class="col-sm-3">
         
          
          </div>
          <div class="col-sm-3">
            <div class="item_name_tht">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Item price</mat-label>
                <input matInput formControlName="price" placeholder="Enter item price" smDecimalOnly  type="number" >
              </mat-form-field>
            </div>
          </div>
          <span class="remove_btn" (click)="removeFormField(i)">Remove</span>
        </div>
      </div>
    </div>
  
    <div class="add_item_btbh">
      <button type="button" mat-flat-button color="accent" (click)="addFormField()">
        <mat-icon>add</mat-icon>
        Add item
      </button>
    </div>
  </form> -->

    <div class="other_itemi_secty">
      <div class="oth_headingrt">
        <h3>Other items</h3>
      </div>
      <form [formGroup]="form">
        <div formArrayName="items">
          <div
            *ngFor="let item of items.controls; let i = index"
            [formGroupName]="i"
            class="repect_under"
          >
            <div class="ad">
              <div class="asa">
                <div class="item_name_tht">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Item name</mat-label>
                    <input
                      matInput
                      formControlName="name"
                      [matAutocomplete]="auto"
                      type="text"
                      placeholder="Enter item name"
                    />
                    <mat-autocomplete
                      #auto="matAutocomplete"
                      [displayWith]="displayItemName"
                    >
                      <mat-option
                        *ngFor="let option of filteredOptions[i] | async"
                        [value]="option"
                      >
                        {{ option.item_name }}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
              </div>
              <div class="ddf">
                <mat-form-field appearance="outline">
                  <mat-select class="w-100" formControlName="tax_slab">
                    <mat-option value="default"> Select a tax </mat-option>
                    <mat-option
                      [value]="item.hash_id"
                      *ngFor="let item of taxSlabData"
                    >
                      {{
                        isEntityForeign == "0" ? item.tax_name : item.slab_name
                      }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="adad">
                <div class="plus_tht newclassw" style="padding-top: 0px">
                  <div class="flexsc">
                    <div class="inc_dec_cont newinc">
                      <span
                        class="cont_span"
                        style="
                          margin-left: 0px !important;
                          top: 0px;
                          border: 1px solid #a2a2a2;
                          padding: 13px !important;
                          border-radius: 10px;
                          position: relative;
                          bottom: 0px;
                          width: 125px;
                          display: block;
                          margin-right: 10px;
                        "
                      >
                        <button
                          type="button"
                          class="inc_dec_btn"
                          (click)="decreaseCount(i)"
                        >
                          <mat-icon>remove</mat-icon>
                        </button>
                        <span style="margin: 0 15px">{{
                          item.get("count")!.value
                        }}</span>
                        <button
                          type="button"
                          class="inc_dec_btn"
                          (click)="increaseCount(i)"
                        >
                          <mat-icon>add</mat-icon>
                        </button>
                      </span>
                    </div>
                  </div>
                  <div class="item_name_tht itempricex">
                    <mat-form-field appearance="outline">
                      <mat-label>Item price</mat-label>
                      <input
                        matInput
                        formControlName="price"
                        placeholder="Enter item price"
                        smDecimalOnly
                        type="number"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <span class="remove_btn" (click)="removeFormField(i)"
                >Remove</span
              >
            </div>
          </div>
        </div>

        <div class="add_item_btbh">
          <button
            type="button"
            mat-flat-button
            color="accent"
            (click)="addFormField()"
          >
            <mat-icon>add</mat-icon>
            Add item
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- new section -->
  <div
    style="
      border-bottom: 1px solid lightgray;
      margin-bottom: 5px;
      padding-bottom: 12px;
    "
  >
    <div class="details_rte" style="margin-bottom: 20px; padding: 0 18px 0 0">
      <div class="subscription_fees" style="font-size: 16px">
        Subscription fee
      </div>
      <div
        class="subscription_price"
        style="text-align: right; font-size: 16px"
      >
        {{ memberData.price.toFixed(2) }}
      </div>
    </div>
    <div
      class="details_rte"
      style="margin-bottom: 20px; padding: 0 18px 0 0"
      *ngIf="memberData.coupon_code"
    >
      <div class="subscription_fees" style="font-size: 16px">
        Coupon discount
        <span
          *ngIf="
            this.memberDetailsData?.coupon_use_limit != 0 &&
            this.memberDetailsData?.coupon_use_limit ==
              this.memberDetailsData?.coupon_use_counter
          "
          >(Expired)</span
        >
      </div>
      <div
        class="subscription_price"
        style="text-align: right; font-size: 16px"
      >
        {{ memberData.coupon_discount.toFixed(2) }}
      </div>
    </div>
    <div class="details_rte" style="padding: 0 18px 0 0">
      <div class="subscription_fees" style="font-size: 16px">Discount</div>
      <div class="subscription_price" style="text-align: right">
        <input [(ngModel)]="memberData.discount" matInput />
      </div>
    </div>
  </div>

  <div>
    <div
      class="details_rte"
      style="margin-top: 20px; margin-bottom: 15px; padding: 0 18px 0 0"
    >
      <div class="subscription_fees" style="font-size: 16px; color: #222">
        Net payable
      </div>
      <div
        class="subscription_price"
        style="text-align: right; font-size: 16px; color: #222"
      >
        {{
          (
            memberData.price -
            memberData.discount -
            memberData?.coupon_discount
          ).toFixed(2)
        }}
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" *ngIf="editmode">
  <button mat-button mat-dialog-close>Cancel</button>
  <button
    mat-flat-button
    color="accent"
    [disabled]="
      selectedJobs.length == 0 ||
      form.invalid || checkIfEmpty2() || checkIfEmptyForProduct2()
    "
    (click)="onPost()"
  >
    Confirm
  </button>
</mat-dialog-actions>
